import { useState, useEffect } from 'react'
import { AuthService } from '../services/auth-service'

import type { SessaoBase } from '../types/auth'

type AuthState = SessaoBase

interface UseAuthReturn extends AuthState {
  logout: () => void
  atualizarSessao: () => Promise<boolean>
}

/**
 * Hook de autenticação voltado para sessões criadas via magic link (hub_login).
 * Responsável apenas por verificar, atualizar e encerrar a sessão local.
 */
export function useAuth(): UseAuthReturn {
  const [authState, setAuthState] = useState<AuthState>({
    isAuthenticated: false,
    cliente: null,
    loading: true,
    error: null,
  })

  useEffect(() => {
    const sessao = AuthService.verificarSessao()
    setAuthState(prev => ({
      ...prev,
      ...sessao,
    }))
  }, [])

  const logout = () => {
    AuthService.logout()
    setAuthState({
      isAuthenticated: false,
      cliente: null,
      loading: false,
      error: null,
    })
  }

  const atualizarSessao = async (): Promise<boolean> => {
    const sucesso = await AuthService.atualizarSessao()

    if (sucesso) {
      const sessaoAtualizada = AuthService.verificarSessao()
      setAuthState(prev => ({
        ...prev,
        ...sessaoAtualizada,
      }))
    }

    return sucesso
  }

  return {
    ...authState,
    logout,
    atualizarSessao,
  }
}
